
export default function ServiceStack() {
  const steps = [
    {
      title: '选品对接',
      subtitle: '精准匹配产地供应商',
      icon: 'search',
      tags: ['产地匹配', '供应商对接', '样品寄送']
    },
    {
      title: '打样/柔性定制',
      subtitle: '小批量试单，灵活生产',
      icon: 'pencil-ruler',
      tags: ['小批量试单', '柔性生产', 'OEM/ODM']
    },
    {
      title: '质检合规',
      subtitle: '全流程质量与认证保障',
      icon: 'shield-check',
      tags: ['质量检验', '认证服务', '合规文件']
    },
    {
      title: '物流/海外仓',
      subtitle: '国际物流与仓储一体化',
      icon: 'truck',
      tags: ['国际物流', '海外仓储', '清关服务']
    },
    {
      title: '交付/售后',
      subtitle: '全程追踪与售后支持',
      icon: 'customer-service-2',
      tags: ['订单追踪', '售后支持', '退换货处理']
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#fdf6f0] to-white">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            从产地到海外交付的一站式服务栈
          </h2>
          <p className="text-lg text-gray-500 max-w-[560px] mx-auto">
            全流程服务保障，让跨境贸易更简单
          </p>
        </div>

        <div className="relative">
          <div className="absolute top-16 left-0 right-0 h-0.5 bg-gradient-to-r from-[#8B1A1A] via-[#C9A84C] to-[#8B1A1A] opacity-20"></div>

          <div className="grid grid-cols-5 gap-6">
            {steps.map((step, idx) => (
              <div key={idx} className="relative">
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-[#8B1A1A] text-white rounded-full flex items-center justify-center font-bold text-sm shadow-lg z-10">
                  {idx + 1}
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#C9A84C]/40 group cursor-pointer mt-6 hover:-translate-y-1">
                  <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#8B1A1A] to-[#C9A84C] rounded-xl mb-4 mx-auto group-hover:scale-110 transition-transform">
                    <i className={`ri-${step.icon}-line text-2xl text-white`}></i>
                  </div>

                  <h3 className="text-lg font-bold text-gray-900 text-center mb-2">
                    {step.title}
                  </h3>

                  <p className="text-sm text-gray-500 text-center mb-4">
                    {step.subtitle}
                  </p>

                  <div className="flex flex-wrap gap-2 justify-center">
                    {step.tags.map((tag, tIdx) => (
                      <span
                        key={tIdx}
                        className="inline-flex items-center px-3 py-1 bg-[#8B1A1A]/8 text-[#8B1A1A] rounded-full text-xs font-medium border border-[#8B1A1A]/15 whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                {idx < steps.length - 1 && (
                  <div className="absolute top-20 -right-3 w-6 h-6 flex items-center justify-center text-[#C9A84C] z-20">
                    <i className="ri-arrow-right-line text-2xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
